import React from "react";
import BusinessHero from "./BusinessHero";
import BusinessTrustBar from "./BusinessTrustBar";
import BusinessBenefits from "./BusinessBenefits";
import BusinessHowItWorks from "./BusinessHowItWorks";
import BusinessLoginSample from "./BusinessLoginSample";
import BusinessCompliance from "./BusinessCompliance";
import BusinessCta from "./BusinessCta";
import Footer from "../../components/Footer/Footer";
import { PageWrapper } from "./BusinessLanding.elements";
import SEOHelmet from "../../components/SEOHelmet/SEOHelmet";

const businessStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Business Verification Nigeria",
  "serviceType": "Business Identity Verification",
  "provider": {
    "@type": "Organization",
    "name": "e-citizen",
    "url": "https://e-citizen.ng"
  },
  "description": "Verify Nigerian company registration via CAC, confirm ownership, and access full business profiles instantly. Make confident business decisions with official data.",
  "areaServed": {
    "@type": "Country",
    "name": "Nigeria"
  },
  "url": "https://e-citizen.ng/business-verification",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "NGN",
    "availability": "https://schema.org/InStock"
  }
};

const BusinessVerificationPage = () => {
  return (
    <PageWrapper>
      <SEOHelmet
        title="Business Verification Nigeria – Verify CAC Registration & Ownership | e-citizen"
        description="Instantly verify Nigerian business registration (CAC), ownership, and company profiles. Confirm if a business is legitimate before any transaction. Fast, secure, and official."
        canonical="/business-verification"
        keywords="business verification Nigeria, CAC verification, company registration check Nigeria, verify business Nigeria, ecitizen business"
        structuredData={businessStructuredData}
      />
      <BusinessHero />
      <BusinessTrustBar />
      <BusinessBenefits />
      <BusinessHowItWorks />
      <BusinessLoginSample />
      <BusinessCompliance />
      <BusinessCta />
      <Footer />
    </PageWrapper>
  );
};

export default BusinessVerificationPage;

